module.exports = __webpack_public_path__ + "static/media/calculator-preview.3711acc2.jpeg";